import React from 'react';

import { formatDateStringWithTimezone } from '../../../utils/formatters';
import BooleanIcon from '../../elements/booleanIcon';
import Card from '../../elements/common/Card';
import ShowMoreBlock from '../../elements/common/ShowMoreBlock';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';
import renderDrawRules from '../../elements/lotteries/DrawRules';
import renderNumbers from '../../elements/lotteries/Numbers';

function LotteryDetails({ lottery }: { lottery: any }) {
    const renderDrawDates = (dates: string[]) => (dates?.length > 0 ? dates.join(', ') : '');

    return (
        <Card title="Lottery details">
            <TableDetailsBody>
                <Row label="Name">{lottery.name}</Row>
                <Row label="Enabled">
                    <BooleanIcon value={lottery.is_enabled} />
                </Row>
                <Row label="Default">
                    <BooleanIcon value={lottery.is_default} />
                </Row>
                <Row label="Draw dates" showIf={lottery.draw_dates?.length > 0}>
                    <ShowMoreBlock>{renderDrawDates(lottery.draw_dates)}</ShowMoreBlock>
                </Row>
                <Row label="Draw rules">{renderDrawRules(lottery.lottery_rule)}</Row>
                <Row label="Timezone">{lottery.timezone}</Row>
                <Row label="Last (next) draw date">
                    {`${formatDateStringWithTimezone(
                        lottery.last_draw_date,
                        lottery.timezone
                    )} (${formatDateStringWithTimezone(lottery.next_draw_date, lottery.timezone)})`}
                </Row>
                <Row label="Last numbers">{renderNumbers(lottery.last_numbers, lottery.name, lottery.type)}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default LotteryDetails;
